import React from 'react';
import PropTypes from 'prop-types';
import {
  withMobileDialog,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  Button,
  TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { addDashboard } from '@pingum/app-state-management/dashboard/actions';
import TenantService from '@pingum/api-services/TenantService';
import DashboardService from '@pingum/api-services/DashboardService';

// components
import Property from '../../../../widgets/Property';

// utils
import {
  getTenantFromUrl,
  getQueryParam,
} from '../../../../../utils/urlHelper';
import propTypes from '../../../../../utils/propTypes';

export class CopyDashboardDialogComponent extends React.Component {
  constructor(props) {
    super(props);

    const name = 'Copy of '.concat(this.props.currentFilterDashboard.name);
    this.state = {
      validation: {
        isValid: true,
        message: '',
      },
      newDashboard: {
        name,
        defaultView: getQueryParam('view'),
        directLinkName: TenantService.normalizeName(name),
        organizationExposed: false,
        dashboardData: this.props.currentFilter,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentFilterDashboard.id !== this.props.currentFilterDashboard.id
        || prevProps.currentView !== this.props.currentView
    ) {
      const name = 'Copy of '.concat(this.props.currentFilterDashboard.name);
      this.setState({
        validation: {
          isValid: true,
          message: '',
        },
        newDashboard: {
          name,
          defaultView: getQueryParam('view'),
          directLinkName: TenantService.normalizeName(name),
          organizationExposed: false,
          dashboardData: this.props.currentFilter,
        },
      });
    }
  }

  handleClose = () => {
    this.props.handleClose();
  }

  handleConfirm = () => {
    if (this.state.validation.isValid) {
      this.state.newDashboard.dashboardData.includeArchived
       = this.state.newDashboard.dashboardData.includeArchived || false;
      this.state.newDashboard.dashboardData.includeComplete
       = this.state.newDashboard.dashboardData.includeComplete || false;
      this.state.newDashboard.dashboardData.searchText
        = this.state.newDashboard.dashboardData.searchText || '';

      this.props.addDashboard(this.state.newDashboard);
      this.props.handleConfirm(this.state.newDashboard);
    }
  }

  handleNameChange = (e) => {
    const changedValue = e.target.value;
    const isValid = changedValue !== null && changedValue !== undefined
    && changedValue.length >= 2 && changedValue.length <= 50;
    this.setState((prevState) => ({
      validation: {
        isValid,
        message: !isValid
          ? <span><br />Please provide a valid name (between 2 and 50 characters in length).</span>
          : '',
      },
      newDashboard: {
        name: changedValue,
        defaultView: getQueryParam('view'),
        directLinkName: TenantService.normalizeName(changedValue),
        organizationExposed: prevState.newDashboard.organizationExposed,
        dashboardData: this.props.currentFilter,
      },
    }));
  }

  handleToggleChange = ({ target: { checked } = {} }) => {
    this.setState((prevState) => ({
      newDashboard: {
        ...prevState.newDashboard,
        organizationExposed: checked,
      },
    }));
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        fullScreen={this.props.fullScreen}
        onClose={this.handleClose}
        aria-labelledby="copy-dialog-title"
        aria-describedby="copy-dialog-description"
      >
        <DialogTitle id="copy-dialog-title">Copy Dashboard</DialogTitle>
        <DialogContent>
          <h4 style={{ marginBottom: 24 }}>
            Copy the current dashboard filter to a new dashboard.
          </h4>
          <TextField
            id="new-dashboard-input"
            fullWidth
            label="Dashboard Name"
            error={!this.state.validation.isValid}
            value={this.state.newDashboard.name}
            onChange={this.handleNameChange}
            labelWidth={125}
            variant="outlined"
            helperText={
                !this.state.validation.isValid
                && this.state.validation.message
}
          />

          <Property label="Direct Link">
            <a
              href={DashboardService.getDashboardUrl(
                TenantService.getTenantUrl(getTenantFromUrl()),
                this.state.newDashboard.directLinkName,
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {
                DashboardService.getDashboardUrl(
                  TenantService.getTenantUrl(getTenantFromUrl()),
                  this.state.newDashboard.directLinkName,
                )
              }
            </a>
          </Property>
          <Property label="Dashboard View">
            {this.props.currentView}
          </Property>

          { this.props.userIsAdmin
            && (
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={this.state.newDashboard.organizationExposed}
                    onChange={this.handleToggleChange}
                    value="organizationExposed"
                  />
                )}
                label="Share Dashboard With Organization"
              />
            )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose}>
            Cancel
          </Button>
          <Button
            onClick={this.handleConfirm}
            color="primary"
            autoFocus
            variant="contained"
          >
            Create a Copy
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

CopyDashboardDialogComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  currentView: PropTypes.string,
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  userIsAdmin: PropTypes.bool.isRequired,
  currentFilterDashboard: PropTypes.any.isRequired,
  currentFilter: PropTypes.shape(propTypes.searchEvents),
  addDashboard: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool,
};

CopyDashboardDialogComponent.defaultProps = {
  currentFilter: {},
  currentView: 'List',
  fullScreen: false,
};

export const mapStateToProps = (state) => ({ currentFilterDashboard: state.dashboard.currentFilterDashboard });

export const mapDispatchToProps = (dispatch) => ({ addDashboard: (request) => dispatch(addDashboard(request)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog({ breakpoint: 'xs' })(CopyDashboardDialogComponent));
